










































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import App from '../App.vue'
import { ToolAppData } from '../models/ToolAppData'
import ErrorDialog from './ErrorDialog.vue'
import ValidationErrorsCard from './ValidationErrorsCard.vue'
import ActionsCard from './ActionsCard.vue'
import { FailureResponseData } from '../models/FailureResponseData'
import TitleCard from './TitleCard.vue'

@Component({
  components: { ErrorDialog, ValidationErrorsCard, ActionsCard, TitleCard },
})
export default class ApplicationDialog extends App {
  private get getTitle() {
    if (this.isValidEdit()) {
      return `Edit ${this.item.name}`
    } else {
      return 'Create New Application'
    }
  }
  @Prop({ default: false })
  public isShown!: boolean
  @Prop({ default: false })
  public isEdit: boolean = false
  @Prop({ required: false })
  public item!: ToolAppData

  private privateIsShown: boolean = false
  private errorDialogIsShown: boolean = false
  private failure: FailureResponseData = new FailureResponseData()

  // private types: string[] = EnumHelpers.GetProductOrToolTypes();

  private name: string = ''
  private assemblyName: string = ''
  private className: string = ''

  @Watch('isShown')
  public onIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    this.privateIsShown = value
  }

  @Watch('privateIsShown')
  public onprivateIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    if (value) {
      this.setDefaultData()
      if (this.isValidEdit()) {
        this.name = this.item.name
        this.assemblyName = this.item.assemblyName
        this.className = this.item.className
      }
    } else {
      this.$emit('dialogClosed')
      this.loading = false
    }
  }

  public async commitChanges() {
    if (!this.checkForm()) {
      return
    }

    this.loading = true

    try {
      const res: ToolAppData = new ToolAppData(this.name, this.assemblyName, this.className, '')

      const errorObject: Object = ''
      const errorsOccurred: boolean = false

      if (this.isValidEdit()) {
        this.$emit('editApp', this.item, res)
      } else {
        this.$emit('addApp', res)
      }
      this.privateIsShown = false
    } catch (e) {
      this.failure = new FailureResponseData(e.message)
      this.errorDialogIsShown = true
    }

    this.loading = false
  }

  public cancelled(item) {
    this.privateIsShown = false
    this.$emit('dialogCancelled')
  }

  private setDefaultData() {
    this.name = ''
    this.assemblyName = ''
    this.className = ''

    this.resetValidation()
  }

  private isValidEdit() {
    return this.isEdit && this.item != null
  }

  private checkForm() {
    this.validationErrors = []

    const form: any = this.$refs.form
    if (form) {
      return form.validate()
    } else {
      if (!this.name) {
        this.validationErrors.push('Name is required.')
      }
      if (!this.assemblyName) {
        this.validationErrors.push('Assembly name is required.')
      }
      if (!this.className) {
        this.validationErrors.push('Class name is required.')
      }
      return this.validationErrors.length === 0
    }
  }
}
